import React from 'react';
import "./Gauge.scss";
interface GaugeProps {
  value: number;
  min: number;
  max: number;
  danger?: [number, number];
  warning?: [number, number];
}

const Gauge: React.FC<GaugeProps> = ({ value, min, max, danger, warning }) => {
  const validMin = isNaN(min) ? 0 : min;
  const validMax = isNaN(max) ? 100 : max;
  const range = validMax - validMin;

  const valueToPercent = (v: number): number => {
    if (range <= 0) return 0;
    const clamped = Math.min(Math.max(v, validMin), validMax);
    return ((clamped - validMin) / range) * 100;
  };

  const currentValuePercent = valueToPercent(value);
  const determineSeverity = (): string => {
    if (danger && value >= danger[0] && value <= danger[1]) {
      return 'danger';
    }
    if (warning && value >= warning[0] && value <= warning[1]) {
      return 'warning';
    }
    return 'safe';
  };

  const severityClass = determineSeverity();

  const dangerStartPercent = danger ? valueToPercent(danger[0]) : 0;
  const dangerEndPercent = danger ? valueToPercent(danger[1]) : 0;

  const warningStartPercent = warning ? valueToPercent(warning[0]) : 0;
  const warningEndPercent = warning ? valueToPercent(warning[1]) : 0;

  return (
    <div className="linear-gauge-container">
      <div className="linear-gauge-track">
                {danger && (
          <div 
            className="linear-gauge-segment danger" 
            style={{ 
              left: `${dangerStartPercent}%`, 
              width: `${dangerEndPercent - dangerStartPercent}%` 
            }}
            title={`Danger: ${danger[0]} - ${danger[1]}`}
          ></div>
        )}
        {warning && (
          <div 
            className="linear-gauge-segment warning" 
            style={{ 
              left: `${warningStartPercent}%`, 
              width: `${warningEndPercent - warningStartPercent}%` 
            }}
            title={`Warning: ${warning[0]} - ${warning[1]}`}
          ></div>
        )}

        <div 
          className={`linear-gauge-progress ${severityClass}`} 
          style={{ width: `${currentValuePercent}%` }}
        ></div>
                <div 
          className="linear-gauge-pointer" 
          style={{ left: `${currentValuePercent}%` }}
        ></div>
        
        <div className="linear-gauge-label min-label">{validMin}</div>
        <div className="linear-gauge-label max-label">{validMax}</div>

      </div>
            <div className="linear-gauge-legend">
        <div className={`legend-item safe`}>محدوده امن</div>
        {warning && <div className="legend-item warning">محدوده هشدار {warning[0]}–{warning[1]}</div>}
        {danger && <div className="legend-item danger">محدوده خطر {danger[0]}–{danger[1]}</div>}
      </div>
    </div>
  );
};

export default Gauge;